import Component from '@glimmer/component';

interface UiInputGroupHintSignature {
  Element: HTMLSpanElement;
  Args: {
    Named: {
      id: string;
    };
  };
  Blocks: {
    default: [];
  };
}

export default class UiInputGroupHintComponent extends Component<UiInputGroupHintSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::InputGroup::Hint': typeof UiInputGroupHintComponent;
    'ui/input-group/hint': typeof UiInputGroupHintComponent;
  }
}
